import request from "./axiosConfig";

/**
 * 查询资讯列表
 */
export function getNewsList() {
  return request({
    url: "/interface/information/list",
    method: "get",
  });
}

/**
 * 查询资讯列表（资讯中心使用）
 */
export function getInformationList(pageNum = 1, pageSize = 10) {
  return request({
    url: "/interface/information/list",
    method: "get",
    params: { pageNum, pageSize }
  });
}

/**
 * 查询资讯详情
 */
export function getInformationDetail(id) {
  return request({
    url: `/interface/information/${id}`,
    method: "get",
  });
}

/**
 * 查询资讯详情（别名，兼容旧代码）
 */
export function getNewsDetail(id) {
  return getInformationDetail(id);
}

/**
 * 查询150问问题详情
 */
export function getQuestionDetail(id) {
  return request({
    url: "/interface/news/newsbyid",
    method: "get",
    params: { id: id }
  });
}